<div matDialogTitle>Select groups to publish to:</div>

<div mat-dialog-content fxLayout="column">

  <div *ngIf="!loading && groups.length < 1">No groups.</div>

  <mat-form-field fxFlex>
    <input type="text" matInput placeholder="Filter..." [(ngModel)]="searchText" />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <div fxLayout="column" fxLayoutAlign="center center" class="group-list" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>

  <div fxLayout="column" class="group-list" *ngIf="!loading">
    <mat-checkbox
      *ngFor="let group of groups | filterGroups: searchText"
      [(ngModel)]="selectedGroups[group.uuid].checked"
      [disabled]="selectedGroups[group.uuid].disabled"
    >
      {{ group.name }}
    </mat-checkbox>
  </div>
</div>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <button mat-button matDialogClose>Cancel</button>
  <button mat-raised-button (click)="close()" color="primary">Save</button>
</mat-dialog-actions>
